// Lighter "Powered by RestoMag" footer lockup (PRD §7, FR-2c).
export function PoweredByFooter() {
  return (
    <footer className="mt-auto py-6 text-center text-xs text-neutral-400">
      Powered by <span className="font-semibold text-neutral-500">RestoMag</span>
    </footer>
  );
}
